module.exports = __webpack_public_path__ + "img/campus-small-2.68a08a8e.jpg";